<div class="dashboard_card" (click)="navigate();handleClick()">
    <span>{{name}}</span>
    <img src="{{image_link[code]}}">
</div>

